import brfCompanyFilters from '@/app/dashboard/brf-associations/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { BrfCompanyConfig, type BrfCompany } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
export const BrfCompanyItem: RelationFieldProps<BrfCompany> = {
  nested: getRelationFieldNames(BrfCompanyConfig),
  filters: brfCompanyFilters,
  renderItem: (item, isRelationField) => {
    return {
      title: item.company?.name ?? '',
      descriptionItems: (
        <div
          className={cn(
            'flex items-center',
            isRelationField && 'w-full justify-between'
          )}
        >
          <span className='font-medium'>
            Org.no {item.company?.orgNo ?? 'Inget organisationsnummer angivet'}
          </span>
        </div>
      ),
    };
  },
};
